import { CanvasRenderingTarget2D } from 'fancy-canvas'
import { ColorType, ISeriesPrimitivePaneRenderer, LineStyle } from 'lightweight-charts'
import LabelledVerticalLineDrawing from './labelledVerticalLine.drawing'


class VerticalLinePaneRenderer implements ISeriesPrimitivePaneRenderer {
    drawing: LabelledVerticalLineDrawing

    constructor(drawing: LabelledVerticalLineDrawing) {
        this.drawing = drawing;
    }

    draw(target: CanvasRenderingTarget2D) {

        if (!this.drawing.chart || !this.drawing.options.lineVisible) return;

        target.useBitmapCoordinateSpace(scope => {
            const { horizontalPixelRatio, verticalPixelRatio, mediaSize: { height }, context: ctx } = scope
            const canvasHeight = height * verticalPixelRatio;
            const { price, width: lineWidth, lineType, opacity, color, showLabel, label,  } = this.drawing.options
            const xCoordinate = this.drawing.chart.timeScale().timeToCoordinate(price);

            if (!xCoordinate) return;

            if (lineType === LineStyle.Dashed) {
                ctx.setLineDash([4*verticalPixelRatio, 2*verticalPixelRatio])
            }
            const scaledX = xCoordinate*horizontalPixelRatio;
            ctx.beginPath();
            ctx.moveTo(scaledX,0);
            ctx.lineTo(scaledX, canvasHeight);
            ctx.strokeStyle = color;
            ctx.lineWidth = lineWidth*horizontalPixelRatio;
            ctx.globalAlpha = opacity;
            ctx.stroke();
            ctx.closePath();

            if (showLabel && label) {
                const dpr = window.devicePixelRatio || 1;
				const fontSize = 12 * dpr;
				ctx.font = `${fontSize}px Arial`;
				const textWidth = ctx.measureText(label).width;
				const paddingX = 4 * dpr;
				const paddingY = 2 * dpr;
				const rectWidth = textWidth + 2 * paddingX;
				const rectHeight = fontSize + 2 * paddingY;
				const radius = 4 * dpr;

				ctx.save();
				ctx.translate(scaledX, 5*dpr + textWidth/2);
				ctx.rotate(-Math.PI / 2);

                const background = this.drawing.chart.options().layout.background
                ctx.fillStyle = background.type === ColorType.Solid ? background.color : 'white';
                ctx.beginPath()
                ctx.globalAlpha = 1;
                ctx.roundRect(
					-textWidth - paddingX,
					-rectHeight / 2,
					rectWidth,
					rectHeight,
					radius
				);
                ctx.fill();
                ctx.closePath();

				// Text
				ctx.textAlign = 'left';
				ctx.textBaseline = 'middle';
				ctx.fillStyle = color;
                ctx.globalAlpha = opacity;
				ctx.fillText(label, -textWidth, paddingY);

				ctx.restore();
            }
        })
    }
    destroy() {
        this.drawing = null;
    }
}


export default VerticalLinePaneRenderer